import React from 'react';
import { ThemeProvider } from 'styled-components';

import theme from '../../../../assets/stylesheets/_settings.global.scss';
import { Container, ContentContainer } from '../shared/styles';
import { propTypes } from './prop-types';
import Form from './form-components/form';

export default function EditAdvertising(props) {
  return (
    <ThemeProvider theme={theme}>
      <Container>
        <ContentContainer>
          <h1>Editing Advertising</h1>
          <Form {...props} />
        </ContentContainer>
      </Container>
    </ThemeProvider>
  );
}

EditAdvertising.propTypes = propTypes;
